import { createFileRoute } from "@tanstack/react-router";
import { SpokePage, buildSpokeHead, type SpokePageConfig } from "@/components/SpokePage";
import heroImg from "@/assets/towns/pueblo-west.jpg";

const CONFIG: SpokePageConfig = {
  slug: "web-design-seo-pueblo-west",
  metaTitle: "Pueblo West Web Design & SEO | Local Google Maps Help",
  metaDescription: "Web design and SEO for Pueblo West, CO businesses. Websites from $1,850, local SEO and Google Maps from $950/month. Based in Colorado Springs, month-to-month.",
  breadcrumbs: [{ label: "Home", to: "/" }, { label: "Colorado Springs Headquarters", to: "/colorado-springs-headquarters" }],
  currentLabel: "Pueblo West",
  eyebrow: "Pueblo West, CO · Pueblo County",
  h1: (
    <>
      Web Design &amp; SEO in <span className="text-brand-gold">Pueblo West, Colorado</span>
    </>
  ),
  heroDescription: "Help Pueblo West customers find you first on Google, Google Maps and AI search.",
  intro: "We build websites and local SEO for businesses in Pueblo West and the Highway 50 corridor. Chris Heidlebaugh works from our Woodmen Rd office in Colorado Springs, within our 60-mile service area, with 27 years of experience helping local companies get found.",
  definition: { term: "Pueblo West local SEO", body: "Making your business show up when people in and around Pueblo West search Google, Google Maps and AI tools for what you offer." },
  whatWeDo: [
    { title: "Pueblo West website", body: "A fast site with pages for your services and the Pueblo West area." },
    { title: "Google Maps", body: "A complete profile with photos, services and steady reviews." },
    { title: "Nearby towns", body: "Pages for Pueblo, Cañon City and Colorado City too." },
    { title: "AI search", body: "Plain answers ChatGPT and Google can repeat." },
    { title: "Clear pricing", body: "Websites from $1,850. Marketing from $950/mo." },
    { title: "Free audit", body: "See what is holding your Pueblo West rankings back." },
  ],
  whyThisMarket: [
    { heading: "Local searches", body: "A fast-growing community where homeowners search for nearby help instead of driving into Pueblo." },
    { heading: "Pueblo County", body: "We know Pueblo County and serve it from Colorado Springs." },
    { heading: "No long contracts", body: "Monthly marketing is month-to-month." },
  ],
  relatedLinks: [
    { to: "/marketing-pueblo-west", label: "Marketing in Pueblo West: social, ads, reviews & Maps" },
    { to: "/colorado-springs-headquarters", label: "Our 60-mile service area" },
    { to: "/colorado-springs-office-woodmen-rd", label: "Our Woodmen Rd office" },
    { to: "/pricing", label: "Pricing" },
    { to: "/free-mockup", label: "Get a free website mockup" },
    { to: "/free-audit", label: "Get a free marketing audit" },
    { to: "/web-design-castle-rock-colorado", label: "Castle Rock web design company" },
  ],
  faqs: [
    { q: "Do you work with businesses in Pueblo West?", a: "Yes. Pueblo West is in our 60-mile service area around Colorado Springs. We can meet in person or by video." },
    { q: "How much does a website cost?", a: "Websites are $1,850, $2,750 or $5,950 one-time with one year of hosting and SSL. Monthly marketing is $950, $1,650 or $2,750 per month." },
    { q: "How fast can my website be ready?", a: "Most websites are ready in under 7 business days." },
  ],
  serviceName: "Web Design and SEO in Pueblo West, CO",
  serviceDescription: "Web design, local SEO and Google Maps help for Pueblo West, Colorado businesses.",
  heroImage: { src: heroImg, alt: "Pueblo West, Colorado neighborhoods above Lake Pueblo", geo: { lat: 38.35, lng: -104.7228, city: "Pueblo West, CO" } },
  areaServed: "Pueblo West, CO",
};

export const Route = createFileRoute("/web-design-seo-pueblo-west")({
  head: () => buildSpokeHead(CONFIG),
  component: () => <SpokePage config={CONFIG} />,
});
